import React, { Component } from 'react';
import Rate from 'rc-rate';

class EtapaAvaliarConteudo extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = {}
    // }
    render() {

        return (<div>

            {this.props.estudoFinalizado && <div>
                <p className="edb-text-bold"><i className="edb-xlarge adap-text-green far fa-check-circle" title="Estudo finalizado"></i> Obrigado por sua avaliação!</p>
                <p>Este estudo ainda ficará disponivel para que você reveja o conteúdo e também como se saiu nas questões.</p>
            </div>}

            {!this.props.estudoFinalizado && <React.Fragment>
                <div className="edb-large edb-text-bold edb-margin-bottom">Pronto! Agora nos diga o que você achou</div>

                <p>Que nota de 1 a 5 você dá para este conteúdo?</p>
                <Rate count={5} character={<i className="fas fa-star edb-xlarge"></i>} onChange={this.props.onChangeNota} />

                <textarea
                    className="edb-margin-top"
                    style={{ width: "100%", height: "150px" }}
                    placeholder="Escreva aqui críticas ou sugestões..."
                    onChange={(event) => this.props.onChangeComentario(event.target.value)}
                    disabled={this.props.estudoFinalizado}></textarea>
            </React.Fragment>}
        </div>);
    }
}

export default EtapaAvaliarConteudo;